export const _hourFormatter = (param: any) => {
    const time = new Date(param).toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
    });
  
    return time || '';
  };
  